export default __webpack_public_path__ + "static/media/36I-102633_-37327_0.a6984582.jpg";